import AppHeader from '../AppHeader'

export default {
  name: 'message-sent-harassment',
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-sent-harassment.js